<template>
  <v-app id="inspire">
    <v-app-bar
      elevation="0"
      style="background: none !important"
      v-if="token && user && $vuetify.breakpoint.mobile"
    >
      <v-col class="mt-6 px-0">
        <v-autocomplete
          v-model="model"
          prepend-icon="mdi-magnify"
          :items="items"
          dense
          rounded
          :loading="isLoading"
          filled
          :search-input.sync="search"
          hide-no-data
          @change="goTo"
          hide-selected
          id="v-step-1"
          item-text="search_nom"
          :placeholder="$t('city_or_cp')"
          return-object
          no-filter
        ></v-autocomplete>
      </v-col>
    </v-app-bar>
    <v-app-bar
      app
      clipped-left
      fixed
      style="flex:none!important;"
      elevate-on-scroll
      v-if="token && user && !$vuetify.breakpoint.mobile"
    >
      <v-toolbar-title

      style="flex:none!important;"
        v-if="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs"
      >
        {{$wm.title}}
      </v-toolbar-title>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn icon @click="$router.go(-1)"
        ><v-icon>mdi-arrow-left</v-icon></v-btn
      >

      <v-autocomplete
        class="mt-6"
        v-model="model"
        :items="items"
        :loading="isLoading"
        dense
        filled
        :search-input.sync="search"
        hide-no-data

          id="v-step-1"
        @change="goTo"
        hide-selected
        item-text="search_nom"
        :placeholder="$t('city_or_cp')"
        return-object
        no-filter
        rounded
      ></v-autocomplete>

      <v-progress-linear
        v-if="routerLoading"
        indeterminate
        absolute
        bottom
      ></v-progress-linear>
      <v-spacer></v-spacer>
      <template v-if="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs">
        {{$t('hello')}},&nbsp;
        <span class="font-weight-bold" v-if="user">{{ user.user_prenom }}</span>
      </template>
      <v-btn small icon class="mx-4" to="/alertes/v2/list">
        <v-badge
          v-if="nbOfAlertsUnread.length"
          :content="nbOfAlertsUnread.length || '0'"
          small
          color="error"
          overlap
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
        <v-icon v-else>mdi-bell</v-icon>
      </v-btn>
      <v-btn small icon class="mx-4" @click="logout()">
        <v-icon color="error">mdi-logout</v-icon>
      </v-btn>
      <template v-if="user.features.find((map) => map == 'admin')">
        <v-btn icon small :to="`/admin`"
          ><v-icon>mdi-account-cowboy-hat</v-icon></v-btn
        >
      </template>
    </v-app-bar>

    <v-navigation-drawer
      touchless
      v-if="token && user"
      class="accent lighten-1 menu"
      v-model="drawer"
      fixed
      app
      clipped
    >
    <div 
      id="v-step-0">
      <v-list>
        <template v-for="(item, i) in menu" :link="!item.menu">
          <template v-if="$env.VUE_APP_WHITE_MARK_ID && item.dedicated ? item.dedicated.includes($env.VUE_APP_WHITE_MARK_ID) : false || !$env.VUE_APP_WHITE_MARK_ID">
          <v-list-group :key="i" v-if="item.menu.length > 1">
            <template v-slot:activator>
              <v-list-item-title class="white--text"
                ><b>{{ item.label }}</b></v-list-item-title
              >
            </template>

            <template v-for="(sub, i) in item.menu">
              <template v-if="$env.VUE_APP_WHITE_MARK_ID && sub.dedicated ? sub.dedicated.includes($env.VUE_APP_WHITE_MARK_ID) : false || !$env.VUE_APP_WHITE_MARK_ID">
                
              <template
                v-if="item.subLabel === 'sites' || item.subLabel === 'services'"
              >
                <v-list-item
                  v-if="
                    !sub.rules || user.features.find((map) => map == sub.rules)
                  "
                  exact
                  :href="sub.to"
                  :key="i"
                  target="_blank"
                >
                  <v-list-item-title
                    v-html="`- ${sub.label}`"
                    class="white--text"
                  ></v-list-item-title>
                </v-list-item>
              </template>
              <template v-else>
                <v-list-item exact :to="sub.to" :key="i" link>
                  <v-list-item-icon
                    v-if="
                      !user.features.find((map) => map == sub.rules) &&
                      sub.rules
                    "
                    ><v-icon>mdi-lock</v-icon></v-list-item-icon
                  >
                  <v-list-item-icon v-else-if="sub.icon"
                    ><v-icon>{{ sub.icon }}</v-icon></v-list-item-icon
                  >
                  <v-list-item-title
                    :class="
                      !user.features.find((map) => map == sub.rules) &&
                      sub.rules
                        ? 'grey--text'
                        : 'white--text'
                    "
                    ><span v-html="sub.label"
                  /></v-list-item-title>
                </v-list-item>
              </template>

            </template>
            </template>
          </v-list-group>
          <v-list-item
            v-else-if="item.menu[0]"
            :key="i"
            link
            :to="item.menu[0].to"
          >
            <span class="white--text"
              ><b>{{ item.menu[0].label }}</b></span
            >
          </v-list-item>
        </template>
        </template>
        <v-list-item @click="logout" link
          ><span class="red--text font-weight-bold"
            ><v-icon>mdi-logout</v-icon> {{$t('logout')}}</span
          ></v-list-item
        >
      </v-list>
    </div>
    </v-navigation-drawer>

    <v-main class="pb-12">
      <v-progress-linear
      indeterminate
      size="2"
      v-if="loading"
      color="yellow darken-2"
    ></v-progress-linear>
      <router-view :key="$route.path"/>
    </v-main>
    <v-overlay color="white" v-if="mainloading" class="text-center">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
      <h3 class="primary--text">{{$t('load_in_progress')}}</h3>
    </v-overlay>
    <v-dialog
      :width="$vuetify.breakpoint.mobile ? '100vw' : '50vw'"
      v-model="news"
    >
      <v-card>
        <v-card-text>
          <v-col>
            <iframe
              width="100%"
              :height="$vuetify.breakpoint.mobile ? '200px' : '500px'"
              src="https://www.youtube.com/embed/4_9wSfhtwWI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <h1>What's news on MyPrevimeteo today ?</h1>
            <ul class="mt-3">
              <li>Features improvments</li>
              <li>Features improvments</li>
              <li>Features improvments</li>
              <li>Features improvments</li>
              <li>Features improvments</li>
            </ul>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-btn block elevation="0" color="primary">Alright</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-navigation
      fixed
      :style="getPlatform == 'ios' ? 'padding-bottom: 80px !important;': ''"
      app
      v-if="$vuetify.breakpoint.mobile && token && user"
    >
      <v-btn small to="/" value="recent">
        <span>{{$t('menu_forecasts')}}</span>

        <v-icon>mdi-weather-sunny</v-icon>
      </v-btn>


      <v-btn small to="/stations" value="favorites">
        <span>{{$t('menu_stations')}}</span>

        <v-icon>mdi-wifi</v-icon>
      </v-btn>
      <v-btn small to="/maps/radar" value="nearby">
        <span>{{$t('menu_map')}}</span>

        <v-icon>mdi-map</v-icon>
      </v-btn>

      <v-btn to="/alertes/v2/list" value="nearby">
        <span>{{$t('menu_alerts')}}</span>

        <v-badge
          v-if="nbOfAlertsUnread.length"
          :content="nbOfAlertsUnread.length || '0'"
          small
          color="error"
          overlap
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
        <v-icon v-else> mdi-bell </v-icon>
      </v-btn>
      <v-btn small to="/profil" value="nearby">
        <span>{{$t('menu_profil')}}</span>

        <v-icon>mdi-account</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <template v-if="$route.query">
    <v-dialog v-model="$route.query.haveAccess">
      <v-card>
        <v-card-text>
          <v-col class="text-center">
            <v-icon x-large color="success">mdi-check</v-icon>
              <h1 class="success--text my-6"> Merci pour votre achat</h1>
              <v-btn rounded block color="primary" class="py-4" to="/maps/radar">Découvrir</v-btn>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
    </template>
    <v-overlay v-if="loadingMagicAuth">
      <v-card light>
        <v-card-text>
          <v-col class="text-center">
          <v-progress-circular indeterminate/>
          <h1>Une petite seconde nous vous connectons ...</h1>
          </v-col>
        </v-card-text>
      </v-card>
    </v-overlay>
   <v-tour name="myTour" :options="myOptions" :steps="steps">
   </v-tour>
  </v-app>

</template>

<script>
/* eslint-disable */


import { mapState } from "vuex";
import api from "@/api";
import * as md5 from "md5";

import {
  Capacitor,
  Plugins,
  PushNotification,
  PushNotificationToken,
  PushNotificationActionPerformed,
} from "@capacitor/core";

const { PushNotifications } = Plugins;

export default {
  computed: {
    steps()
    {
      return [
         !this.$vuetify.breakpoint.mobile && {
            target: '#v-step-0',  // We're using document.querySelector() under the hood
            header: {
              title: `Présentation ${this.$wm.title}`,
            },
            content: `👈 Retrouvez tous vos menus ici`,
             params: {
              placement: 'right' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            },
          },
          {
            target: '#v-step-1',  // We're using document.querySelector() under the hood
            header: {
              title: `Présentation ${this.$wm.title}`,
            },
            content: `Si vous n'avez pas de favoris vous devez entrer le nom d'une ville ou son code postal`,
             params: {
              placement: 'bottom' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
            },
          },
        ]
        },
    ...mapState('loader', ['loading']), 
    getPlatform()
    {
    return Capacitor.getPlatform();
    },
    ...mapState(["user", "token", "routerLoading", "mainloading", "alerts"]),
    nbOfAlertsUnread() {
      if (this.alerts.length == 0) return 0;
      return this.alerts.filter((map) => map.lu == "0");
    },
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },

    items() {
      return this.entries.map((chunk) =>
        chunk.cp
          ? {
              ...chunk,
              search_nom: `${chunk.nom} (${chunk.cp.slice(0, 2)}) ${chunk.iso}`,
            }
          : { ...chunk, search_nom: `${chunk.nom} ${chunk.iso}` }
      );
    },

    menu() {
      if (!this.user) return [];
      if (!this.user.favoris) return [];

      let favoris = this.user.favoris;
      let cities_menu = [];
      let stations = this.user.stations;
      let stations_menu = [];

      stations_menu.push({
        to: `/stations/create`,
        label: this.$t("navbar.stations.create"),
      });

      stations_menu.push({
        to: `/stations`,
        label: this.$t("navbar.stations.all"),
      });

      stations.forEach((element) => {
        stations_menu.push({
          dedicated:["pm","fp"],
          to: `/stations/${element.id_station}`,
          label: element.libelle_station,
          icon: "mdi-wifi",
        });
      });

      favoris.forEach((element) => {
        cities_menu.push({
          dedicated:["pm","fp"],
          to: `/forecasts/${element.id_ville}/${element.libelle_lien}/resum`,
          label: this.htmlDecode(element.libelle_lien),
        });
      });
      
      
      if (this.$env.VUE_APP_WHITE_MARK_ID == 'monithermo') {
        return [
          {
            label: this.$t("navbar.home.title"),
            menu: [{ to: "/", label: this.$t("navbar.home.dashboard") }],
          },
          {
            label: this.$t("navbar.stations.title"),
            menu: stations_menu,
          },
          {
            label: this.$t("navbar.cities"),
            menu: cities_menu,
          },
          {
            label: this.$t("navbar.alerts.title"),
            menu: [
              {
                to: "/alertes/v2/list",
                label: this.$t("navbar.alerts.all"),
                rules: "alerts",
              },
            ],
          },
          {
            to: "https://admin-one.justboil.me",
            label: this.$t("navbar.profile"),
            menu: [
              {
                to: "/profil",
                label: this.$t("my_account"),
              },
            ],
          }
          
        ];
      }

      return [
        {
          label: this.$t("navbar.home.title"),
          menu: [{ to: "/", label: this.$t("navbar.home.dashboard") }],
          dedicated:['fp',"pm"]
        },
        {
          label: this.$t("navbar.stations.title"),
          menu: stations_menu,
          dedicated:['fp',"pm"]
        },
        {
          label: this.$t("navbar.cities"),
          menu: cities_menu,
          dedicated:['fp',"pm"]
        },
        {
          label: this.$t("navbar.alerts.title"),
          dedicated:['fp',"pm"],
          menu: [
            {
              to: "/alertes/v2/list",
              label: this.$t("navbar.alerts.all"),
              rules: "alerts",
            },
          ],
        },
        {
          label: this.$t("navbar.radar.title"),
          dedicated:["fp","pm"],
          menu: [
            {
              dedicated:["pm"],
              to: "/weathermaps",
              rules: "weathermaps",
              label: this.$t("navbar.maps"),
              icon: "mdi-map",
            },
            {
              dedicated:["pm"],
              to: "/maps/radar",
              rules: "radar_precipitations",
              label: this.$t("radar_sat"),
              icon: "mdi-weather-rainy",
            },
            {
              to: "/maps/stormwatch",
              dedicated:["fp","pm"],
              rules: "stormwatch",
              label: this.$t("navbar.stormwatch"),
              icon: "mdi-weather-lightning",
            },
          ],
        },
        {
          to: "/profil",
          label: this.$t("navbar.profile"),
          dedicated:["fp","pm"],
          menu: [
            {
              to: "/profil",
              label: this.$t("my_account"),
            },
          ],
        },
        {
          label: this.$t("navbar.services.title"),
          subLabel: "services",
          menu: [
            {
              to: "https://services.previmeteo.com/fr/certificat-intemperies.html?utm_source=MyPM&utm_medium=Menu%20Lateral&utm_campaign=Certificats",
              label: this.$t("navbar.services.certificates"),
            },
            {
              to: "https://services.previmeteo.com/fr/webservices-api-meteo-sites-internet.php?utm_source=MyPM&utm_medium=Menu%20Lateral&utm_campaign=API",
              label: this.$t("navbar.services.webservices"),
            },
            {
              to: "https://services.previmeteo.com/fr/abonnement-meteo-pro.php?utm_source=MyPM&utm_medium=Menu%20Lateral&utm_campaign=Abonnements",
              label: this.$t("navbar.services.subscriptions"),
            },
            {
              to: "https://services.previmeteo.com/fr/reception-alertes-meteo.php?utm_source=MyPM&utm_medium=Menu%20Lateral&utm_campaign=Alertes",
              label: this.$t("navbar.services.alerts"),
            },
          ],
        },
        {
          label: this.$t("navbar.sites"),
          subLabel: "sites",
          menu: [
            {
              to: "https://alerte-orage.fr/?utm_source=MyPM&utm_medium=Menu%20lateral&utm_campaign=Alerte%20Orage",
              label: "Météo Orage",
            },
            {
              to: "https://meteo-btp.com/?utm_source=MyPM&utm_medium=Menu%20lateral&utm_campaign=Meteo%20BTP",
              label: "Météo BTP",
            },
            {
              to: "https://www.meteo-agriculture.com/?utm_source=MyPM&utm_medium=Menu%20lateral&utm_campaign=Meteo%20Agriculture",
              label: "Météo Agriculture",
            },
            {
              to: "https://certificat-intemperies.fr/",
              label: "Certificats d'intempéries",
            },
            {
              to: "https://api-meteo.io/?utm_source=MyPM&utm_medium=Menu%20lateral&utm_campaign=API%20meteo",
              label: "API Météo",
            },
            {
              to: "https://alertes-meteo.fr/?utm_source=MyPM&utm_medium=Menu%20lateral&utm_campaign=alerte%20meteo",
              label: "Alertes Météo",
            },
          ],
        },
      ];
    },
  },

  data: () => ({
    drawer: null,
    news: false,
    descriptionLimit: 60,
    isLoading: false,
    loadingMagicAuth:false,
    entries: [],
    model: null,
    search: null,
    myOptions: {
          useKeyboardNavigation: false,
          labels: {
            buttonSkip: 'Passer',
            buttonPrevious: 'Précédent',
            buttonNext: 'Suivant',
            buttonStop: 'Terminer'
          }
        },
    
  }),

  methods: {
    startTour()
    {
      this.$tours['myTour'].start()
    },
    track () {
      this.$gtag.pageview(this.$route)
    },
    md5,
    OpenChat() {
      window.$crisp.do("chat:open");
    },
    async setLocalNotification() {
      const { LocalNotifications } = Plugins;
      await LocalNotifications.schedule({
        notifications: [
          {
            title: "Votre Météo à Bordeaux",
            body: "Test",
            id: 1,
            schedule: {
              every: "day",
              repeats: true,
              on: { hour: "09", minute: "55" },
            },
            sound: null,
            attachments: null,
            actionTypeId: "",
            extra: null,
          },
        ],
      });
    },
    htmlDecode(input) {
      var doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    },

    logout() {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setToken", null);
      localStorage.removeItem("token")
      // localStorage.clear();
      this.$router.go("/login");
    },

    goTo() {
      this.$router.push(
        `/forecasts/${this.model.geoname}/${this.model.nom}/resum`
      );
    },
    setNotification() {
      var ua = navigator.userAgent.toLowerCase();
      let device = Capacitor.getPlatform();

      if(Capacitor.getPlatform() != 'ios' && Capacitor.getPlatform != 'android') return;
      
      PushNotifications.requestPermission().then((result) => {
        if (result.granted) {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          // Show some error
        }
      });

      // On success, we should be able to receive notifications
      PushNotifications.addListener("registration", (token) => {
        api.notifications.post(this.user.id_user, `${device}@${token.value}`);
      });

      // Some issue with our setup and push will not work
      PushNotifications.addListener("registrationError", (error) => {
        // alert("Error on registration: " + JSON.stringify(error));
      });

      // Show us the notification payload if the app is open on our device
      PushNotifications.addListener(
        "pushNotificationReceived",
        (notification) => {
          // alert("Push received: " + JSON.stringify(notification));
        }
      );

      // Method called when tapping on a notification
      PushNotifications.addListener(
        "pushNotificationActionPerformed",
        (notification) => {
          // alert("Push action performed: " + JSON.stringify(notification));
        }
      );
    },
  },
  async created(){
    document.title = this.$wm.title
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = this.$wm.favico;
  },
  async mounted() {
      console.log(this.$route);
      let urlschem = window.location.href.split('?magic_token=');
      if(urlschem[1]){
        this.loadingMagicAuth = true;
            api.auth_magic(urlschem[1]).then((login) => {
            // Store token & user informations
            this.$store.dispatch("setToken", login.token);
            api.users.get(login.user.id_user).then((user) => {
              this.loadingMagicAuth = false;
              this.$store.dispatch("setUser", user);
              this.$router.push("/");
            });
          }).catch(()=>{
            this.loadingMagicAuth = false;
          });
        }
     this.$i18n.locale = localStorage.getItem("lang") ? localStorage.getItem("lang"):this.$env.VUE_APP_I18N_LOCALE;
    this.track();
  },
  watch: {
    search(val) {
      this.isLoading = true;

      // Lazily load input items
      api.cities
        .search(val)
        .then((res) => {
          this.entries = res;
          this.count = res.length;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => (this.isLoading = false));
    },
    "$route"() {
      this.track();
    },
    user() {
      
      if (this.user) {
        console.log('localtour', localStorage.getItem('localtour'))
        if(!localStorage.getItem('localtour'))
        {
          console.log('so display ?');
          localStorage.setItem('localtour', true);
          this.startTour();
        }
        this.setNotification();
        
        if (this.$route.query.connectas) {
          api.loginAs(this.$route.query.connectas).then((login) => {
            // Store token & user informations
            this.$store.dispatch("setToken", login.token);
            api.users.get(login.user.id_user).then((user) => {
              this.$store.dispatch("setUser", user);
              this.$router.push("/");
            });
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap");

$body-font-family: "Open Sans";
$title-font: "Open Sans";
.v-application {
  font-family: $body-font-family, sans-serif !important;
  .title {
    // To pin point specific classes of some components
    font-family: $title-font, sans-serif !important;
  }
}

.bgpm {
  background-color: #222d32 !important;
}
</style>
<style lang="scss">
body {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.menu {
  .theme--light.v-label,
  .theme--light.v-icon {
    color: rgb(255 255 255 / 60%) !important;
  }
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: rgb(255 255 255 / 87%) !important;
  }
}

.leaflet-container {
  z-index: 0 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.v-application--wrap {
  overflow: hidden;
}

.v-slider__thumb-label {
  width: 100px !important;
  transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(0) !important;
  border-radius: 5px !important;
}

.v-slider--horizontal .v-slider__thumb-label > * {
  transform: rotate(0deg) !important;
}

.crisp-client .cc-unoo {
  display: none !important;
}

.v-item-group.v-bottom-navigation .v-btn {
  min-width: 50px !important;
}


.v-card__title {
  word-break: break-word !important;
}
header.v-sheet.theme--light.elevation-0.v-toolbar.v-app-bar {
    flex: none!important;
}
</style>
